import { faPause, faPrint } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Modal, Radio, Space, Switch, Typography } from 'antd'
import { useEffect, useState } from 'react'
import { JobReportType, JobReportTypes, PrintWorkarea } from './jobPrintModel'

type Props = {
  open: boolean
  jobReportLabel: string
  printWorkareas: PrintWorkarea[]
  isPrinting: boolean
  onToggleWorkarea: (workareaId: number, print: boolean) => void
  onPrintJobReport: () => void
  onPrintItemsSummary: () => void
  onCancel: () => void
}

const SelectJobReportModal = ({
  open,
  jobReportLabel,
  printWorkareas,
  isPrinting,
  onToggleWorkarea,
  onPrintJobReport,
  onPrintItemsSummary,
  onCancel
}: Props) => {
  const [reportType, setReportType] = useState<JobReportType>(JobReportTypes.JobReport)

  useEffect(() => {
    if (open) {
      setReportType(JobReportTypes.JobReport)
    }
  }, [open])

  const handleOk = () => {
    if (reportType === JobReportTypes.ItemsSummary) {
      onPrintItemsSummary()
      return
    }
    onPrintJobReport()
  }

  return <Modal
    title={<Space><FontAwesomeIcon icon={faPrint} /> Select Report to Print</Space>}
    open={open}
    onCancel={onCancel}
    onOk={handleOk}
    okText="Print"
    okButtonProps={{ loading: isPrinting, icon: <FontAwesomeIcon icon={faPrint} /> }}
    cancelText="Cancel"
  >
    <Typography.Paragraph>Select the report you want to print</Typography.Paragraph>

    <Radio.Group value={reportType} onChange={e => setReportType(e.target.value)} style={{ width: '100%' }}>
      <Space direction="vertical" size="middle" style={{ width: '100%' }}>
        <div>
          <Radio value={JobReportTypes.JobReport}>{jobReportLabel}</Radio>
          <Typography.Text type="secondary" style={{ display: 'block', marginLeft: 24 }}>
            {jobReportLabel} highlighting work areas, items and quantities
          </Typography.Text>
        </div>
        <div>
          <Radio value={JobReportTypes.ItemsSummary}>Items Summary Report</Radio>
          <Typography.Text type="secondary" style={{ display: 'block', marginLeft: 24 }}>
            Items Summary report highlighting all actual items
          </Typography.Text>
        </div>
      </Space>
    </Radio.Group>

    {reportType === JobReportTypes.JobReport && <div style={{ marginTop: 24 }}>
      <Typography.Paragraph>Select the tasks to print</Typography.Paragraph>
      <Space direction="vertical" style={{ width: '100%' }}>
        {printWorkareas.map(workarea => <Space key={workarea.id}>
          <Switch
            size="small"
            checked={workarea.print}
            onChange={checked => onToggleWorkarea(workarea.id, checked)}
            aria-label={`Print ${workarea.name}`}
          />
          <span>{workarea.name}</span>
          {workarea.isOnHold && <Typography.Text type="secondary">
            <FontAwesomeIcon icon={faPause} /> workarea on hold
          </Typography.Text>}
        </Space>)}
      </Space>
    </div>}
  </Modal>
}

export default SelectJobReportModal
